<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+learningUnitId" :endpoint-params="endpointParams"
             :props="props" :map="map" :bus="bus"
             :title2="courseTitle" :title3="programTitle" :background-image="backgroundImage">
        </trax-ui-top-box>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-assessment-edit-top-box'},
            programTitle: null,
            courseTitle: null,
            learningUnitId: null,
            backgroundImage: null
        },

        data: function() {
            var endpointParams = {};
            if (data.registration_id) endpointParams.registration_id = data.registration_id;
            return {
                endpoint: app_url+'polaris/api/front/learning-units',
                endpointParams: endpointParams,
                props: {
                    type: { source:'type' },
                    code: { source:'code' },
                    name: { source:'name' },
                    description: {source: 'description'}
                },
                map: {
                    icon: function(data) {
                        return window.data.learning_unit_icons[data.type]
                    },
                    title1: 'code',
                    description: 'description',
                    descriptionTitle: 'name',
                },
                bus: new Vue()
            }
        }

    }
</script>
